import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { ButtonComponent } from './button.component';
/**
 * A module containing objects associated with button components
 */
var ButtonModule = /** @class */ (function () {
    function ButtonModule() {
    }
    ButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule
                    ],
                    declarations: [ButtonComponent],
                    exports: [
                        ButtonComponent,
                        CommonModule,
                        FormsModule
                    ]
                },] },
    ];
    /** @nocollapse */
    ButtonModule.ctorParameters = function () { return []; };
    return ButtonModule;
}());
export { ButtonModule };
//# sourceMappingURL=button.module.js.map